// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MaxTabLimitRow-module__font-s-10___gzHO9 {
  font-size: 10px !important;
}

.MaxTabLimitRow-module__font-s-12___YtkYZ {
  font-size: 12px !important;
}

.MaxTabLimitRow-module__font-s-13___SbedP {
  font-size: 13px !important;
}

.MaxTabLimitRow-module__font-s-14___bxOfA {
  font-size: 14px !important;
}

.MaxTabLimitRow-module__font-s-15___NWRVY {
  font-size: 15px !important;
}

.MaxTabLimitRow-module__font-s-16___mOMEo {
  font-size: 16px !important;
}

.MaxTabLimitRow-module__font-s-18___WX8sW {
  font-size: 18px !important;
}

.MaxTabLimitRow-module__font-s-20___auxBM {
  font-size: 20px !important;
}

.MaxTabLimitRow-module__font-s-22___DZvXh {
  font-size: 22px !important;
}

.MaxTabLimitRow-module__font-s-28___bxrq2 {
  font-size: 28px !important;
}

.MaxTabLimitRow-module__font-w-400___IK0Oz {
  font-weight: 400 !important;
}

.MaxTabLimitRow-module__font-w-500___V1mSM {
  font-weight: 500 !important;
}

.MaxTabLimitRow-module__font-w-600___QxVJ2 {
  font-weight: 600 !important;
}

.MaxTabLimitRow-module__font-w-700___BJMfr {
  font-weight: 700 !important;
}

.MaxTabLimitRow-module__p-5___Wsaky {
  padding: 5px !important;
}

.MaxTabLimitRow-module__p-12___RqibR {
  padding: 12px !important;
}

.MaxTabLimitRow-module__p-16___Nn5He {
  padding: 16px !important;
}

.MaxTabLimitRow-module__p-30___jDr0C {
  padding: 30px !important;
}

.MaxTabLimitRow-module__p-b-0___GxRSv {
  padding-bottom: 0 !important;
}

.MaxTabLimitRow-module__p-b-5___rP6M6 {
  padding-bottom: 5px !important;
}

.MaxTabLimitRow-module__p-b-10___f3O_H {
  padding-bottom: 10px !important;
}

.MaxTabLimitRow-module__p-b-12___aOf_h {
  padding-bottom: 12px !important;
}

.MaxTabLimitRow-module__p-b-16___TkNa0 {
  padding-bottom: 16px !important;
}

.MaxTabLimitRow-module__p-b-18___XgSrQ {
  padding-bottom: 18px !important;
}

.MaxTabLimitRow-module__p-b-20___Z6VRv {
  padding-bottom: 20px !important;
}

.MaxTabLimitRow-module__p-b-25___ldqOX {
  padding-bottom: 25px !important;
}

.MaxTabLimitRow-module__p-b-30___vroKV {
  padding-bottom: 30px !important;
}

.MaxTabLimitRow-module__p-b-50___MLEB1 {
  padding-bottom: 50px !important;
}

.MaxTabLimitRow-module__p-t-0___WKg4W {
  padding-top: 0 !important;
}

.MaxTabLimitRow-module__p-t-12___hMTxD {
  padding-top: 12px !important;
}

.MaxTabLimitRow-module__p-t-16___tB1H9 {
  padding-top: 16px !important;
}

.MaxTabLimitRow-module__p-t-18___TJnKw {
  padding-top: 18px !important;
}

.MaxTabLimitRow-module__p-t-20___UIiub {
  padding-top: 20px !important;
}

.MaxTabLimitRow-module__p-t-30___TLfFG {
  padding-top: 30px !important;
}

.MaxTabLimitRow-module__p-t-40____pECz {
  padding-top: 40px !important;
}

.MaxTabLimitRow-module__p-t-50___g7oqA {
  padding-top: 50px !important;
}

.MaxTabLimitRow-module__p-l-20___cnmIp {
  padding-left: 20px !important;
}

.MaxTabLimitRow-module__p-l-30___ZgCfM {
  padding-left: 30px !important;
}

.MaxTabLimitRow-module__p-l-40___dVaEQ {
  padding-left: 40px !important;
}

.MaxTabLimitRow-module__p-r-16___RFp7N {
  padding-right: 16px !important;
}

.MaxTabLimitRow-module__p-r-20___tgLrc {
  padding-right: 20px !important;
}

.MaxTabLimitRow-module__p-r-30___Q6yrX {
  padding-right: 30px !important;
}

.MaxTabLimitRow-module__p-r-50___OsDhE {
  padding-right: 50px !important;
}

.MaxTabLimitRow-module__p-r-60___PSUt4 {
  padding-right: 60px !important;
}

.MaxTabLimitRow-module__m-b-1___bakwD {
  margin-bottom: 1px !important;
}

.MaxTabLimitRow-module__m-b-2___ioXyS {
  margin-bottom: 2px !important;
}

.MaxTabLimitRow-module__m-b-6___qZ1Pl {
  margin-bottom: 6px !important;
}

.MaxTabLimitRow-module__m-b-8___JSG7T {
  margin-bottom: 8px !important;
}

.MaxTabLimitRow-module__m-b-10___w6bhA {
  margin-bottom: 10px !important;
}

.MaxTabLimitRow-module__m-b-14___as5_4 {
  margin-bottom: 14px !important;
}

.MaxTabLimitRow-module__m-b-16___kjXoV {
  margin-bottom: 16px !important;
}

.MaxTabLimitRow-module__m-b-20___klonl {
  margin-bottom: 20px !important;
}

.MaxTabLimitRow-module__m-b-22___CYuy_ {
  margin-bottom: 22px !important;
}

.MaxTabLimitRow-module__m-b-24___n4FT4 {
  margin-bottom: 24px !important;
}

.MaxTabLimitRow-module__m-b-30___d5xG0 {
  margin-bottom: 30px !important;
}

.MaxTabLimitRow-module__m-b-32___anOq7 {
  margin-bottom: 32px !important;
}

.MaxTabLimitRow-module__m-b-40___gHF5H {
  margin-bottom: 40px !important;
}

.MaxTabLimitRow-module__m-t-2___WiB7I {
  margin-top: 2px !important;
}

.MaxTabLimitRow-module__m-t-3___IN7f3 {
  margin-top: 3px !important;
}

.MaxTabLimitRow-module__m-t-4___dThSp {
  margin-top: 4px !important;
}

.MaxTabLimitRow-module__m-t-5___EyZb3 {
  margin-top: 5px !important;
}

.MaxTabLimitRow-module__m-t-8___i0BL5 {
  margin-top: 8px !important;
}

.MaxTabLimitRow-module__m-t-10___cvKoc {
  margin-top: 10px !important;
}

.MaxTabLimitRow-module__m-t-15___Dk2op {
  margin-top: 15px !important;
}

.MaxTabLimitRow-module__m-t-16___QFTVq {
  margin-top: 16px !important;
}

.MaxTabLimitRow-module__m-t-20___soxkE {
  margin-top: 20px !important;
}

.MaxTabLimitRow-module__m-t-22___taDG9 {
  margin-top: 22px !important;
}

.MaxTabLimitRow-module__m-t-30___t3KYD {
  margin-top: 30px !important;
}

.MaxTabLimitRow-module__m-t-32___A8Qvh {
  margin-top: 32px !important;
}

.MaxTabLimitRow-module__m-l-auto___eFG3w {
  margin-left: auto !important;
}

.MaxTabLimitRow-module__m-l-4___nZTwY {
  margin-left: 4px !important;
}

.MaxTabLimitRow-module__m-l-5___r5ihF {
  margin-left: 5px !important;
}

.MaxTabLimitRow-module__m-l-6___nWtAD {
  margin-left: 6px !important;
}

.MaxTabLimitRow-module__m-l-8___SitbA {
  margin-left: 8px !important;
}

.MaxTabLimitRow-module__m-l-10___W8Ofi {
  margin-left: 10px !important;
}

.MaxTabLimitRow-module__m-l-16___xjMRd {
  margin-left: 16px !important;
}

.MaxTabLimitRow-module__m-l-20___QgmGI {
  margin-left: 20px !important;
}

.MaxTabLimitRow-module__m-l-24___EbfQw {
  margin-left: 24px !important;
}

.MaxTabLimitRow-module__m-l-30___RXftP {
  margin-left: 30px !important;
}

.MaxTabLimitRow-module__m-l-35___OMDPf {
  margin-left: 35px !important;
}

.MaxTabLimitRow-module__m-l-40___XBWOG {
  margin-left: 40px !important;
}

.MaxTabLimitRow-module__m-r-8____huvg {
  margin-right: 8px !important;
}

.MaxTabLimitRow-module__m-r-10___Z9lMX {
  margin-right: 10px !important;
}

.MaxTabLimitRow-module__m-r-16___ihiXr {
  margin-right: 16px !important;
}

.MaxTabLimitRow-module__m-r-20___CtR8a {
  margin-right: 20px !important;
}

.MaxTabLimitRow-module__m-r-24___uDIpo {
  margin-right: 24px !important;
}

.MaxTabLimitRow-module__m-r-30___eSFSD {
  margin-right: 30px !important;
}

.MaxTabLimitRow-module__m-r-40___uJYsv {
  margin-right: 40px !important;
}

.MaxTabLimitRow-module__border-r-3___GM0Ui {
  border-radius: 3px !important;
}

.MaxTabLimitRow-module__border-r-4___ztbCz {
  border-radius: 4px !important;
}

.MaxTabLimitRow-module__border-r-6___k9dFK {
  border-radius: 6px !important;
}

.MaxTabLimitRow-module__border-r-10___v6x5N {
  border-radius: 10px !important;
}

.MaxTabLimitRow-module__border-r-12___xeihP {
  border-radius: 12px !important;
}

.MaxTabLimitRow-module__border-r-16___KKyyi {
  border-radius: 16px !important;
}

.MaxTabLimitRow-module__border-r-50___pk86U {
  border-radius: 50% !important;
}

.MaxTabLimitRow-module__primary-border___sh3Ly {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MaxTabLimitRow-module__primary-border-b___W6bnl {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MaxTabLimitRow-module__primary-border-t___BKg9b {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MaxTabLimitRow-module__primary-border-l___mClHW {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MaxTabLimitRow-module__primary-border-r___qhfZQ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MaxTabLimitRow-module__secondary-border___eBGXh {
  border: 1px solid #637768;
}

.MaxTabLimitRow-module__secondary-border-b___kSpXj {
  border-bottom: 1px solid #637768;
}

.MaxTabLimitRow-module__secondary-border-t___uHQWn {
  border-top: 1px solid #637768;
}

.MaxTabLimitRow-module__secondary-border-l____veTj {
  border-left: 1px solid #637768;
}

.MaxTabLimitRow-module__secondary-border-r___kBDlw {
  border-right: 1px solid #637768;
}

.MaxTabLimitRow-module__gap-0___JO3u_ {
  gap: 0 !important;
}

.MaxTabLimitRow-module__gap-2___lKspB {
  gap: 2px !important;
}

.MaxTabLimitRow-module__gap-4___xVKus {
  gap: 4px !important;
}

.MaxTabLimitRow-module__gap-5___ZeOlm {
  gap: 5px !important;
}

.MaxTabLimitRow-module__gap-6___rA7pL {
  gap: 6px !important;
}

.MaxTabLimitRow-module__gap-8___KBJau {
  gap: 8px !important;
}

.MaxTabLimitRow-module__gap-10___z3IYX {
  gap: 10px !important;
}

.MaxTabLimitRow-module__gap-12___ppAd4 {
  gap: 12px !important;
}

.MaxTabLimitRow-module__gap-14___Z6j6n {
  gap: 14px !important;
}

.MaxTabLimitRow-module__gap-16___zTdAy {
  gap: 16px !important;
}

.MaxTabLimitRow-module__gap-18___SBl9z {
  gap: 18px !important;
}

.MaxTabLimitRow-module__gap-20___Rdy_Q {
  gap: 20px !important;
}

.MaxTabLimitRow-module__gap-24___B3MpY {
  gap: 24px !important;
}

.MaxTabLimitRow-module__gap-26___OMvyR {
  gap: 26px !important;
}

.MaxTabLimitRow-module__gap-30___lfmvZ {
  gap: 30px !important;
}

.MaxTabLimitRow-module__gap-32___HNja1 {
  gap: 32px !important;
}

.MaxTabLimitRow-module__gap-40___PqHjc {
  gap: 40px !important;
}

.MaxTabLimitRow-module__gap-50___Tlm9n {
  gap: 50px !important;
}

.MaxTabLimitRow-module__flex-1___fi0BR {
  flex: 1;
}

.MaxTabLimitRow-module__flex-none___ZoMvC {
  flex: none !important;
}

.MaxTabLimitRow-module__flex-column___wB2ob {
  display: flex;
  flex-direction: column !important;
}

.MaxTabLimitRow-module__flex-row___vbEnw {
  display: flex;
  flex-direction: row !important;
}

.MaxTabLimitRow-module__vertically-centered___5Xwkm {
  display: flex;
  align-items: center !important;
}

.MaxTabLimitRow-module__horizontally-centered___qIBy8 {
  display: flex;
  justify-content: center !important;
}

.MaxTabLimitRow-module__horizontally-end___pxZTi {
  display: flex;
  justify-content: end !important;
}

.MaxTabLimitRow-module__vertically-start___wnoKw {
  display: flex;
  align-items: start !important;
}

.MaxTabLimitRow-module__space-between___ZQjZr {
  display: flex;
  justify-content: space-between !important;
}

.MaxTabLimitRow-module__flex-wrap___nsZFG {
  flex-wrap: wrap !important;
}

.MaxTabLimitRow-module__height-100___A7iTQ {
  height: 100%;
}

.MaxTabLimitRow-module__width-50___FtRQI {
  width: 50% !important;
}

.MaxTabLimitRow-module__width-100___hrHGx {
  width: 100%;
}

.MaxTabLimitRow-module__cursor-pointer___GgWnv {
  cursor: pointer;
}

.MaxTabLimitRow-module__cursor-not-allowed___fkVjP {
  cursor: not-allowed !important;
}

.MaxTabLimitRow-module__absolute-centered___AKeLI {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MaxTabLimitRow-module__absolute___SE4eh {
  position: absolute;
}

.MaxTabLimitRow-module__relative___ec72j {
  position: relative;
}

.MaxTabLimitRow-module__fixed___kSbNm {
  position: fixed;
}

.MaxTabLimitRow-module__visible___d1O51 {
  opacity: 1;
}

.MaxTabLimitRow-module__invisible___LSs8X {
  opacity: 0;
}

.MaxTabLimitRow-module__col-90___RGtUt {
  width: 90% !important;
}

.MaxTabLimitRow-module__col-auto___QTDcN {
  width: auto !important;
}

.MaxTabLimitRow-module__medical-tabs___F8yCg {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MaxTabLimitRow-module__medical-table-new____r7qj {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MaxTabLimitRow-module__medical-table-new____r7qj:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MaxTabLimitRow-module__medical-table-new____r7qj::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MaxTabLimitRow-module__medical-table-new____r7qj::-webkit-scrollbar-track {
  display: none;
}
.MaxTabLimitRow-module__medical-table-new____r7qj.MaxTabLimitRow-module__no-pagination___SuQDv {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MaxTabLimitRow-module__medical-table-new____r7qj.MaxTabLimitRow-module__no-pagination___SuQDv:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MaxTabLimitRow-module__medical-table-new____r7qj.MaxTabLimitRow-module__no-pagination___SuQDv::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MaxTabLimitRow-module__medical-table-new____r7qj.MaxTabLimitRow-module__no-pagination___SuQDv::-webkit-scrollbar-track {
  display: none;
}

.MaxTabLimitRow-module__medical-table-empty___KchmX {
  padding: 14px 40px !important;
}

.MaxTabLimitRow-module__icon-btn___UinLg {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MaxTabLimitRow-module__search-icon___D804v {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MaxTabLimitRow-module__disable-select___XMx1r {
  user-select: none;
}

.MaxTabLimitRow-module__break-word___OWLow {
  word-break: break-word;
}

.MaxTabLimitRow-module__popup-clear-btn___KgARU {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MaxTabLimitRow-module__scroll-m-b-20___lfY7h {
  scroll-margin-bottom: 20px;
}

.MaxTabLimitRow-module__checkboxLabel___srS48 {
  font-family: var(--font-family);
  font-weight: 400;
  color: black;
}

.MaxTabLimitRow-module__checkbox___Bhyr6 {
  width: 50%;
  margin: 0 0 10px 24px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/MaxTabLimitPopup/MaxTabLimitRow/MaxTabLimitRow.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EEwBE,+BApBO;EAqBP,gBCzBQ;EHER,YAAA;AA+pBF;;AA5pBA;EACE,UAAA;EACA,qBAAA;AA+pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.checkboxLabel {\n  @include get-font($roboto, $regular);\n  color: get-color(black);\n}\n\n.checkbox {\n  width: 50%;\n  margin: 0 0 10px 24px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MaxTabLimitRow-module__font-s-10___gzHO9`,
	"fontS12": `MaxTabLimitRow-module__font-s-12___YtkYZ`,
	"fontS13": `MaxTabLimitRow-module__font-s-13___SbedP`,
	"fontS14": `MaxTabLimitRow-module__font-s-14___bxOfA`,
	"fontS15": `MaxTabLimitRow-module__font-s-15___NWRVY`,
	"fontS16": `MaxTabLimitRow-module__font-s-16___mOMEo`,
	"fontS18": `MaxTabLimitRow-module__font-s-18___WX8sW`,
	"fontS20": `MaxTabLimitRow-module__font-s-20___auxBM`,
	"fontS22": `MaxTabLimitRow-module__font-s-22___DZvXh`,
	"fontS28": `MaxTabLimitRow-module__font-s-28___bxrq2`,
	"fontW400": `MaxTabLimitRow-module__font-w-400___IK0Oz`,
	"fontW500": `MaxTabLimitRow-module__font-w-500___V1mSM`,
	"fontW600": `MaxTabLimitRow-module__font-w-600___QxVJ2`,
	"fontW700": `MaxTabLimitRow-module__font-w-700___BJMfr`,
	"p5": `MaxTabLimitRow-module__p-5___Wsaky`,
	"p12": `MaxTabLimitRow-module__p-12___RqibR`,
	"p16": `MaxTabLimitRow-module__p-16___Nn5He`,
	"p30": `MaxTabLimitRow-module__p-30___jDr0C`,
	"pB0": `MaxTabLimitRow-module__p-b-0___GxRSv`,
	"pB5": `MaxTabLimitRow-module__p-b-5___rP6M6`,
	"pB10": `MaxTabLimitRow-module__p-b-10___f3O_H`,
	"pB12": `MaxTabLimitRow-module__p-b-12___aOf_h`,
	"pB16": `MaxTabLimitRow-module__p-b-16___TkNa0`,
	"pB18": `MaxTabLimitRow-module__p-b-18___XgSrQ`,
	"pB20": `MaxTabLimitRow-module__p-b-20___Z6VRv`,
	"pB25": `MaxTabLimitRow-module__p-b-25___ldqOX`,
	"pB30": `MaxTabLimitRow-module__p-b-30___vroKV`,
	"pB50": `MaxTabLimitRow-module__p-b-50___MLEB1`,
	"pT0": `MaxTabLimitRow-module__p-t-0___WKg4W`,
	"pT12": `MaxTabLimitRow-module__p-t-12___hMTxD`,
	"pT16": `MaxTabLimitRow-module__p-t-16___tB1H9`,
	"pT18": `MaxTabLimitRow-module__p-t-18___TJnKw`,
	"pT20": `MaxTabLimitRow-module__p-t-20___UIiub`,
	"pT30": `MaxTabLimitRow-module__p-t-30___TLfFG`,
	"pT40": `MaxTabLimitRow-module__p-t-40____pECz`,
	"pT50": `MaxTabLimitRow-module__p-t-50___g7oqA`,
	"pL20": `MaxTabLimitRow-module__p-l-20___cnmIp`,
	"pL30": `MaxTabLimitRow-module__p-l-30___ZgCfM`,
	"pL40": `MaxTabLimitRow-module__p-l-40___dVaEQ`,
	"pR16": `MaxTabLimitRow-module__p-r-16___RFp7N`,
	"pR20": `MaxTabLimitRow-module__p-r-20___tgLrc`,
	"pR30": `MaxTabLimitRow-module__p-r-30___Q6yrX`,
	"pR50": `MaxTabLimitRow-module__p-r-50___OsDhE`,
	"pR60": `MaxTabLimitRow-module__p-r-60___PSUt4`,
	"mB1": `MaxTabLimitRow-module__m-b-1___bakwD`,
	"mB2": `MaxTabLimitRow-module__m-b-2___ioXyS`,
	"mB6": `MaxTabLimitRow-module__m-b-6___qZ1Pl`,
	"mB8": `MaxTabLimitRow-module__m-b-8___JSG7T`,
	"mB10": `MaxTabLimitRow-module__m-b-10___w6bhA`,
	"mB14": `MaxTabLimitRow-module__m-b-14___as5_4`,
	"mB16": `MaxTabLimitRow-module__m-b-16___kjXoV`,
	"mB20": `MaxTabLimitRow-module__m-b-20___klonl`,
	"mB22": `MaxTabLimitRow-module__m-b-22___CYuy_`,
	"mB24": `MaxTabLimitRow-module__m-b-24___n4FT4`,
	"mB30": `MaxTabLimitRow-module__m-b-30___d5xG0`,
	"mB32": `MaxTabLimitRow-module__m-b-32___anOq7`,
	"mB40": `MaxTabLimitRow-module__m-b-40___gHF5H`,
	"mT2": `MaxTabLimitRow-module__m-t-2___WiB7I`,
	"mT3": `MaxTabLimitRow-module__m-t-3___IN7f3`,
	"mT4": `MaxTabLimitRow-module__m-t-4___dThSp`,
	"mT5": `MaxTabLimitRow-module__m-t-5___EyZb3`,
	"mT8": `MaxTabLimitRow-module__m-t-8___i0BL5`,
	"mT10": `MaxTabLimitRow-module__m-t-10___cvKoc`,
	"mT15": `MaxTabLimitRow-module__m-t-15___Dk2op`,
	"mT16": `MaxTabLimitRow-module__m-t-16___QFTVq`,
	"mT20": `MaxTabLimitRow-module__m-t-20___soxkE`,
	"mT22": `MaxTabLimitRow-module__m-t-22___taDG9`,
	"mT30": `MaxTabLimitRow-module__m-t-30___t3KYD`,
	"mT32": `MaxTabLimitRow-module__m-t-32___A8Qvh`,
	"mLAuto": `MaxTabLimitRow-module__m-l-auto___eFG3w`,
	"mL4": `MaxTabLimitRow-module__m-l-4___nZTwY`,
	"mL5": `MaxTabLimitRow-module__m-l-5___r5ihF`,
	"mL6": `MaxTabLimitRow-module__m-l-6___nWtAD`,
	"mL8": `MaxTabLimitRow-module__m-l-8___SitbA`,
	"mL10": `MaxTabLimitRow-module__m-l-10___W8Ofi`,
	"mL16": `MaxTabLimitRow-module__m-l-16___xjMRd`,
	"mL20": `MaxTabLimitRow-module__m-l-20___QgmGI`,
	"mL24": `MaxTabLimitRow-module__m-l-24___EbfQw`,
	"mL30": `MaxTabLimitRow-module__m-l-30___RXftP`,
	"mL35": `MaxTabLimitRow-module__m-l-35___OMDPf`,
	"mL40": `MaxTabLimitRow-module__m-l-40___XBWOG`,
	"mR8": `MaxTabLimitRow-module__m-r-8____huvg`,
	"mR10": `MaxTabLimitRow-module__m-r-10___Z9lMX`,
	"mR16": `MaxTabLimitRow-module__m-r-16___ihiXr`,
	"mR20": `MaxTabLimitRow-module__m-r-20___CtR8a`,
	"mR24": `MaxTabLimitRow-module__m-r-24___uDIpo`,
	"mR30": `MaxTabLimitRow-module__m-r-30___eSFSD`,
	"mR40": `MaxTabLimitRow-module__m-r-40___uJYsv`,
	"borderR3": `MaxTabLimitRow-module__border-r-3___GM0Ui`,
	"borderR4": `MaxTabLimitRow-module__border-r-4___ztbCz`,
	"borderR6": `MaxTabLimitRow-module__border-r-6___k9dFK`,
	"borderR10": `MaxTabLimitRow-module__border-r-10___v6x5N`,
	"borderR12": `MaxTabLimitRow-module__border-r-12___xeihP`,
	"borderR16": `MaxTabLimitRow-module__border-r-16___KKyyi`,
	"borderR50": `MaxTabLimitRow-module__border-r-50___pk86U`,
	"primaryBorder": `MaxTabLimitRow-module__primary-border___sh3Ly`,
	"primaryBorderB": `MaxTabLimitRow-module__primary-border-b___W6bnl`,
	"primaryBorderT": `MaxTabLimitRow-module__primary-border-t___BKg9b`,
	"primaryBorderL": `MaxTabLimitRow-module__primary-border-l___mClHW`,
	"primaryBorderR": `MaxTabLimitRow-module__primary-border-r___qhfZQ`,
	"secondaryBorder": `MaxTabLimitRow-module__secondary-border___eBGXh`,
	"secondaryBorderB": `MaxTabLimitRow-module__secondary-border-b___kSpXj`,
	"secondaryBorderT": `MaxTabLimitRow-module__secondary-border-t___uHQWn`,
	"secondaryBorderL": `MaxTabLimitRow-module__secondary-border-l____veTj`,
	"secondaryBorderR": `MaxTabLimitRow-module__secondary-border-r___kBDlw`,
	"gap0": `MaxTabLimitRow-module__gap-0___JO3u_`,
	"gap2": `MaxTabLimitRow-module__gap-2___lKspB`,
	"gap4": `MaxTabLimitRow-module__gap-4___xVKus`,
	"gap5": `MaxTabLimitRow-module__gap-5___ZeOlm`,
	"gap6": `MaxTabLimitRow-module__gap-6___rA7pL`,
	"gap8": `MaxTabLimitRow-module__gap-8___KBJau`,
	"gap10": `MaxTabLimitRow-module__gap-10___z3IYX`,
	"gap12": `MaxTabLimitRow-module__gap-12___ppAd4`,
	"gap14": `MaxTabLimitRow-module__gap-14___Z6j6n`,
	"gap16": `MaxTabLimitRow-module__gap-16___zTdAy`,
	"gap18": `MaxTabLimitRow-module__gap-18___SBl9z`,
	"gap20": `MaxTabLimitRow-module__gap-20___Rdy_Q`,
	"gap24": `MaxTabLimitRow-module__gap-24___B3MpY`,
	"gap26": `MaxTabLimitRow-module__gap-26___OMvyR`,
	"gap30": `MaxTabLimitRow-module__gap-30___lfmvZ`,
	"gap32": `MaxTabLimitRow-module__gap-32___HNja1`,
	"gap40": `MaxTabLimitRow-module__gap-40___PqHjc`,
	"gap50": `MaxTabLimitRow-module__gap-50___Tlm9n`,
	"flex1": `MaxTabLimitRow-module__flex-1___fi0BR`,
	"flexNone": `MaxTabLimitRow-module__flex-none___ZoMvC`,
	"flexColumn": `MaxTabLimitRow-module__flex-column___wB2ob`,
	"flexRow": `MaxTabLimitRow-module__flex-row___vbEnw`,
	"verticallyCentered": `MaxTabLimitRow-module__vertically-centered___5Xwkm`,
	"horizontallyCentered": `MaxTabLimitRow-module__horizontally-centered___qIBy8`,
	"horizontallyEnd": `MaxTabLimitRow-module__horizontally-end___pxZTi`,
	"verticallyStart": `MaxTabLimitRow-module__vertically-start___wnoKw`,
	"spaceBetween": `MaxTabLimitRow-module__space-between___ZQjZr`,
	"flexWrap": `MaxTabLimitRow-module__flex-wrap___nsZFG`,
	"height100": `MaxTabLimitRow-module__height-100___A7iTQ`,
	"width50": `MaxTabLimitRow-module__width-50___FtRQI`,
	"width100": `MaxTabLimitRow-module__width-100___hrHGx`,
	"cursorPointer": `MaxTabLimitRow-module__cursor-pointer___GgWnv`,
	"cursorNotAllowed": `MaxTabLimitRow-module__cursor-not-allowed___fkVjP`,
	"absoluteCentered": `MaxTabLimitRow-module__absolute-centered___AKeLI`,
	"absolute": `MaxTabLimitRow-module__absolute___SE4eh`,
	"relative": `MaxTabLimitRow-module__relative___ec72j`,
	"fixed": `MaxTabLimitRow-module__fixed___kSbNm`,
	"visible": `MaxTabLimitRow-module__visible___d1O51`,
	"invisible": `MaxTabLimitRow-module__invisible___LSs8X`,
	"col90": `MaxTabLimitRow-module__col-90___RGtUt`,
	"colAuto": `MaxTabLimitRow-module__col-auto___QTDcN`,
	"medicalTabs": `MaxTabLimitRow-module__medical-tabs___F8yCg`,
	"medicalTableNew": `MaxTabLimitRow-module__medical-table-new____r7qj`,
	"noPagination": `MaxTabLimitRow-module__no-pagination___SuQDv`,
	"medicalTableEmpty": `MaxTabLimitRow-module__medical-table-empty___KchmX`,
	"iconBtn": `MaxTabLimitRow-module__icon-btn___UinLg`,
	"searchIcon": `MaxTabLimitRow-module__search-icon___D804v`,
	"disableSelect": `MaxTabLimitRow-module__disable-select___XMx1r`,
	"breakWord": `MaxTabLimitRow-module__break-word___OWLow`,
	"popupClearBtn": `MaxTabLimitRow-module__popup-clear-btn___KgARU`,
	"scrollMB20": `MaxTabLimitRow-module__scroll-m-b-20___lfY7h`,
	"checkboxLabel": `MaxTabLimitRow-module__checkboxLabel___srS48`,
	"checkbox": `MaxTabLimitRow-module__checkbox___Bhyr6`
};
module.exports = ___CSS_LOADER_EXPORT___;
